// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"7144":"fa3de7d5","7776":"477d4af2"}[chunkId] || chunkId) + "." + {"2692":"096d729dff7d8f68","5539":"884190189c2fe677","7144":"acce98ea2d0a65f9","7776":"f19abfc9b3d1b597","9375":"3246cc98e9e9e9ca","9829":"f32c5e3a2c7a21b5"}[chunkId] + ".js";
};